import { createI18n } from 'vue-i18n';

// Импортируем переводы
import en from './locales/en.json';
import ru from './locales/ru.json';

const messages = {
    en,
    ru,
};

const i18n = createI18n({
    locale: process.env.MIX_APP_LOCALE || 'ru',
    fallbackLocale: 'en',
    messages,
    legacy: false,
    globalInjection: true,
});

export default i18n;

